import clsx from "clsx";
import Link from "next/link";

type BrandMarkProps = {
  className?: string;
  compact?: boolean;
  href?: string;
  inverse?: boolean;
  showDescriptor?: boolean;
};

const BrandMark: React.FC<BrandMarkProps> = ({
  className,
  compact = false,
  href = "/",
  inverse = false,
  showDescriptor = false,
}) => {
  const wordmarkColor = inverse ? "text-white" : "text-[#0C1F3F]";
  const descriptorColor = inverse ? "text-white/60" : "text-[#5C6370]";

  return (
    <Link
      href={href}
      className={clsx("inline-flex rounded-lg", className)}
      aria-label="Inspektomat"
    >
      <span className="flex min-w-0 flex-col">
        <span
          className={clsx(
            "whitespace-nowrap font-jakarta font-extrabold leading-none tracking-[-0.04em]",
            compact ? "text-[17px]" : "text-[18px]",
            wordmarkColor
          )}
        >
          <span className="relative inline-block">
            <span>i</span>
            <span className="absolute left-1/2 top-[0.10em] h-[0.20em] w-[0.20em] -translate-x-1/2 bg-[#00C896]" />
          </span>
          <span>nspektomat</span>
          <span className="text-[#00C896]">.</span>
          <span>pl</span>
        </span>
        {showDescriptor ? (
          <span
            className={clsx(
              "mt-1 font-jakarta text-[10px] font-semibold uppercase tracking-[0.16em]",
              descriptorColor
            )}
          >
            Przeglądy bezpieczeństwa
          </span>
        ) : null}
      </span>
    </Link>
  );
};

export default BrandMark;
